export const isServerRendering = () => typeof document == 'undefined';
